import { render } from "./ProfileImageInput.vue?vue&type=template&id=449ec876&scoped=true"
import script from "./ProfileImageInput.vue?vue&type=script&lang=js"
export * from "./ProfileImageInput.vue?vue&type=script&lang=js"

import "./ProfileImageInput.vue?vue&type=style&index=0&id=449ec876&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449ec876"]])

export default __exports__